(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const supported = 'IntersectionObserver' in window;
  let observer;
  const explicit = [
    '.tbv-series-item', '.tbv-series-intro', '.tbv-series-filters', '.tbv-aphorism', '.tbv-about-hero .page-width', '.tbv-about-block',
    '.tbv-hero-content > :not(h1)', '.tbv-story > *',
    '.tbv-collections > h2', '.tbv-collections > .tbv-eyebrow',
    '.tbv-collection', '.tbv-spotlight > div',
    '#MainContent .main-page-title', '#MainContent .collection-hero__text-wrapper',
    '#MainContent .collection-list > .collection-list__item',
    '#MainContent .title--primary', '#MainContent .contact',
    '#MainContent .grid__item', '#MainContent .product__media-wrapper',
    '#MainContent .product__info-container > *',
    '#MainContent .cart-item', '#MainContent .cart__footer > *',
    '#MainContent .article-template__hero-container',
    '#MainContent .contact > form', '#MainContent .customer > form',
    '.footer__blocks-wrapper > *', '.footer-block--newsletter', '.footer__content-bottom'
  ].join(',');
  const generic = '#MainContent h1, #MainContent h2, #MainContent h3, #MainContent p, #MainContent .rte, #MainContent img, #MainContent video, #MainContent iframe, #MainContent form';
  const excluded = '.tbv-hero h1, .tbv-hero-image, .tbv-wave-bar, dialog, [role="dialog"], .quick-add-modal, .product-media-modal, .menu-drawer, .cart-drawer, .slider-buttons, .facets, .mobile-facets, .loading-overlay, [hidden]';
  function reveal(root = document) {
    if (reduced.matches || !supported) return;
    // Animate content groups as a unit, avoiding nested transforms on their controls.
    const preferred = [...root.querySelectorAll(explicit)];
    const candidates = [...preferred, ...root.querySelectorAll(generic)];
    const selected = [...new Set(candidates)].filter(node => {
      if (node.closest(excluded)) return false;
      if (preferred.some(parent => parent !== node && parent.contains(node))) return false;
      // An existing reveal group also owns content inserted into it later.
      if (node.parentElement?.closest('[data-tbv-motion]')) return false;
      return true;
    });
    selected.forEach((node, index) => {
      if (node.dataset.tbvMotion || !node.getClientRects().length) return;
      node.dataset.tbvMotion = 'ready';
      if (node.getBoundingClientRect().bottom < 0) return;
      node.classList.add('tbv-reveal');
      const hero = node.closest('.tbv-hero');
      node.style.setProperty('--tbv-delay', `${hero ? Math.min(index, 5) * 140 : 220 + (index % 4) * 100}ms`);
      // Commit the hidden starting state before watching visible content.
      // Without this, already-visible targets can skip the transition entirely.
      requestAnimationFrame(() => requestAnimationFrame(() => {
        if (!node.isConnected) return;
        if (reduced.matches) show(node);
        else observer.observe(node);
      }));
    });
  }
  function show(node) {
    node.classList.add('tbv-visible');
    observer?.unobserve(node);
  }
  function start() {
    if (supported) observer = new IntersectionObserver(entries => {
      entries.forEach(entry => { if (entry.isIntersecting) show(entry.target); });
    }, { threshold: 0 });
    reveal();
    document.addEventListener('shopify:section:load', event => reveal(event.target));
    ['shopify:section:select', 'shopify:block:select'].forEach(name => document.addEventListener(name, event => {
      show(event.target);
      event.target.querySelectorAll('.tbv-reveal').forEach(show);
    }));
    // Keyboard users never have to wait for a focused control to appear.
    document.addEventListener('focusin', event => {
      const group = event.target.closest('.tbv-reveal');
      if (group) show(group);
    });
    reduced.addEventListener('change', () => {
      if (reduced.matches) document.querySelectorAll('.tbv-reveal').forEach(show);
      else reveal();
    });
    // Dawn replaces collection and recommendation markup without a full page load.
    let pending = false;
    const main = document.getElementById('MainContent');
    if (main) new MutationObserver(records => {
      if (pending || !records.some(record => record.addedNodes.length)) return;
      pending = true;
      requestAnimationFrame(() => { pending = false; reveal(main); });
    }).observe(main, { childList: true, subtree: true });
    // Printing should include every section, even below the viewport.
    window.addEventListener('beforeprint', () => document.querySelectorAll('.tbv-reveal').forEach(show));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
